/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Card_Sales_TextInputs */

const en_contact_card_sales_text = /** @type {(inputs: Contact_Card_Sales_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring Listening to your educational institution or company`)
};

const es_contact_card_sales_text = /** @type {(inputs: Contact_Card_Sales_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lleva Listening a tu institución educativa o empresa`)
};

/**
* | output |
* | --- |
* | "Bring Listening to your educational institution or company" |
*
* @param {Contact_Card_Sales_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const contact_card_sales_text = /** @type {((inputs?: Contact_Card_Sales_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Card_Sales_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_card_sales_text(inputs)
	return en_contact_card_sales_text(inputs)
});